import uidinput from '../../components/UidInputComponent.vue';
import airportselect from '../../components/AirportSelectComponent.vue';
import Form from '../../form';
import Errors from "../../errors";
import Vue from "vue";

let app = new Vue({
        el: '#app-vipindex',

        data: {
            form: new Form({
                uid: '',
                airport: '',
                payservice: false
            }),
            openbookings: []
        },

        components: {
            uidinput,
            airportselect
        },
        mounted() {
            let airports = window.configValues.airports;
            if(airports.length == 1) {
                this.form.airport = airports[0].code
            }
        },
        methods: {
            onSubmit() {
                this.form.post(document.getElementById('vipbookingform').getAttribute('action'))
                    .then(response => {
                        console.log(response);
                        if(response.open) {
                            swal({
                                type: 'warning',
                                text: window.translations.open_booking[window.locale]
                            });
                            this.openbookings = response.open;
                            return;
                        }
                        if(response.target) {
                            document.getElementById('vipbookingform').setAttribute('action', response.target);
                            document.getElementById('vipbookingform').submit()
                        }
                    })
                    .catch();
            }
        }
    });

export default app;